<template>
  <div>
    <h1 class="te-terms-page-title co-display-8 mb-14 mt-5 text-center leading-none md:mb-20">
      利用規約
    </h1>
    <div class="mb-10">
      <h2 class="co-display-7 mb-7 border-b-[3px] border-co-gray-200 py-3 font-bold tracking-normal">
        第1章（総則）
      </h2>
      <p class="mb-4 ml-4 leading-8">
        当社は、当社が運営するTechAcademyのオンラインブートキャンプ（以下「本サービス」といいます。）を利用することに関して、以下の通り本オンラインブートキャンプ利用規約（以下「本規約」といいます。）を定めます。 本サービスの利用をお申込みいただく際は、事前に本規約を十分ご理解いただいた上でご同意いただくものとし、本サービスの申し込みを行った時点で本規約の内容を承諾したものとみなされるものとします。
      </p>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第1条（サービス）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        会員（第2条に定める会員登録が完了した者をいいます。）は本サービスにて学習したいコースを選択し、当社所定の手続を経ることにより、オンライン上で当該コースのコンテンツを閲覧・学習することができます。
      </p>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第2条（申込及び登録）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社所定の登録に必要となる情報を当社の定める方法で当社に提供することにより、当社に対し、会員登録の申請を行うことができます。
        </li>
        <li class="mb-2">
          当社は登録希望者に対する面接の実施等、当社所定の手続及び基準に従って、会員登録の申請に対し、登録の可否を判断し、登録を認める場合にはその旨をメールにて通知し、これにより会員登録が完了します。なお、当社は会員に対して選考結果理由について、何ら説明する義務はないものとします。
        </li>
        <li class="mb-2">
          登録希望者は、以下の各号の事由を確認の上、申請しなければならないものとします。なお、登録希望者は、外部サービスや外部アプリケーションについては、それらのサービスやアプリケーションの利用規約等に従って利用するものとします。なお当社は本サービスに関連して登録希望者が利用する外部サービスや外部アプリケーションの安全性について一切責任を負いません。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              外部サービス「Slack」にてアカウントを作成の上、本サービスを受講目的で登録すること
            </li>
            <li class="mb-2">
              「Google Chrome」「Slack」「Github」「AWS Cloud9」「Xcode」「Android Studio」「Unity」「Adobe Photoshop」「Prott」「Sketch」「Gyazo」その他の当社が指定する外部アプリケーションを当社が指定するバージョンでインストールすること。
            </li>
            <li class="mb-2">
              コンピュータ、Webカメラ及びマイク等、本サービスの利用に必要な機器を準備すること
            </li>
            <li class="mb-2">
              通信環境が本サービスの利用に支障がないことを確認すること
            </li>
            <li class="mb-2">
              メンターは、当社の社員以外にも業務委託者も含まれること
            </li>
            <li class="mb-2">
              当社は登録希望者に対し、Web面接による選考が行うこと、及び選考結果により、登録希望者は受講を認められない可能性があること。
            </li>
          </ol>
        </li>
        <li class="mb-2">
          会員は、会員登録内容に変更があった場合は、速やかに会員情報画面にて修正するものとします。
        </li>
        <li class="mb-2">
          会員が前項の通知を怠ったことにより、本サービスの利用に支障が生じたり、その他会員がいかなる不利益を被ったとしても、当社は、何ら責任を負わないものとします。
        </li>
        <li class="mb-2">
          前項に定める登録の完了時に、会員と当社との間で、本規約の諸規定に従ったサービス利用契約が成立した上で、当社の定める利用料金の支払いが確認できた場合には、会員は本サービスを当社の定める方法に従って利用することができるようになります。
        </li>
        <li class="mb-2">
          当社は、登録希望者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              会員登録に関連して当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
            </li>
            <li class="mb-2">
              第3項各号に定めた事由を遵守しない場合
            </li>
            <li class="mb-2">
              当該登録希望者が、本サービス利用に際して、過去にアカウント削除等の本サービス利用停止措置を受けたことがあり又は現在受けている場合
            </li>
            <li class="mb-2">
              登録希望者が当社が指定した支払方法による支払ができない場合
            </li>
            <li class="mb-2">
              過去に当社に対する代金の支払いを怠っていた場合
            </li>
            <li class="mb-2">
              未成年者、成年被後見人、被保佐人又は被補助人のいずれかであって、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合
            </li>
            <li class="mb-2">
              反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。）であるか、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等、反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合
            </li>
            <li class="mb-2">
              その他、本サービスの会員として不適当であると当社が判断する場合
            </li>
          </ol>
        </li>
        <li class="mb-2">
          会員は、会員登録の際に登録した名前、メールアドレス、ID、パスワード等のログイン情報及び本サービスの利用に必要な情報（以下、「アクセス情報」といいます。）を、自らの責任で厳重に保管するものとします。また会員は本サービス上で行われた全ての利用について責任を負います。当社は、ログイン時に入力されたアクセス情報と登録されたものとの一致をもって本サービスの利用が会員本人によるものであるとみなすことができるものとします。
        </li>
        <li class="mb-2">
          会員登録は、会員に一身専属的に帰属します。会員は、アクセス情報を第三者に使用させまたは共有してはならず、また、第三者への譲渡、貸与、名義変更、売買等も行ってはならず、相続等させることはできません。
        </li>
        <li class="mb-2">
          会員は、アクセス情報を失念した場合または第三者に不正に使用されている疑いがある場合、当社に対して速やかに連絡し、当社の指示等に従わなければなりません。なお、会員は、同連絡を速やかにせずまた当社の指示等に従わないことにより生じる全ての損害等について責任を負うものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第3条（利用可能時間）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        会員は、有効に利用登録されている期間内に限り、本規約の目的の範囲内でかつ本規約に違反しない範囲内で、当社の定める方法に従い、本サービスを利用することができます。本サービスの利用可能時間は、以下の通りとします。
      </p>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          コンテンツの閲覧・・・24時間（メンテナンス時間を除く）
        </li>
        <li class="mb-2">
          メンターによる質問の返信、レビュー対応時間（以下、「メンター指導時間」といいます。）・・・コースごとに別途定められた時間内
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第4条（利用料金及び支払方法）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員が本サービスを利用する場合、当社に当社所定の利用料金を支払うものとします。サービスの利用料金及びその支払方法は、別途当社が定め、本サービス又は当社ウェブサイト上に表示するものとします
        </li>
        <li class="mb-2">
          本サービスは、会員本人のアカウントに対してのみ使用が許諾されます。本サービスのコース変更、追加購入などの処理及び手続に関しましては、別途当社が定め、本サービス又は当社ウェブサイト上に表示するものとします。
        </li>
        <li class="mb-2">
          お支払方法は、銀行振込、クレジットカードその他当社が指定する方法となります。なお銀行振込の場合の振込手数料は会員の負担とします。
        </li>
        <li class="mb-2">
          クレジットカードのお支払形態は、一括払い、分割払いのいずれかとなります。お申込み時に、ご希望のお支払形態をご選択ください。ただし、一括払い以外のお支払につきましては、各クレジットカード会社の規定によりご利用できない場合があります。なお、分割払い利用時のカード手数料は会員の負担となります。
        </li>
        <li class="mb-2">
          ご利用にあたって、クレジットカードの種別、名義人名、番号、有効期限、生年月日をお支払い方法入力ページでご入力いただくことが必要となります。
        </li>
        <li class="mb-2">
          会員による代金のお支払いは、各クレジットカード会社の会員規約に基づくお支払いとなります。なお、会員のクレジットカードが使用されたとみなされる日は、会員によって申し込みがなされた日といたします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第5条（利用期間）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          本サービスの利用期間は、会員が購入したコースの開催期間とします。ただし、本コースの一部のカリキュラム閲覧は、アカウント発行後から可能になるものとします。
        </li>
        <li class="mb-2">
          会員が本サービスにお申し込み後、当社へのキャンセルの連絡及び前条の料金の入金がなく、入金期日を過ぎた場合には、自動的に次回の同様のコースの開催期間が申し込み会員の利用期間となり、申し込み会員は、当社に対しキャンセルの連絡をしない場合、次回の同様のコースの入金期日までに前条の料金を支払うものとします。
        </li>
        <li class="mb-2">
          会員が利用期間において中途解約を行った場合であっても、前条の料金の返金は行いません。また、会員が利用料金の支払いを遅滞した場合、会員は年14.6％の割合による遅延損害金を当社に支払うものとします。
        </li>
        <li class="mb-2">
          会員が利用期間開始日の1営業日前までに当社の指定する方法にて解約する旨の通知を当社に対して行った場合は、会員は本サービスを解約できるものとします。なおこの場合、当社は会員に対し、すでに当社に対して入金された料金の返金を行います。また、返金の際の振込手数料は会員が負担するものとします。
        </li>
        <li class="mb-2">
          ただし、会員が初回ログインを実施した日以降は、前項にかかわらず解約はできないものとし、前条の利用料金の返金は一切行わないものとします。
        </li>
      </ol>
    </div>

    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第6条（メンタリング）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、当社所定の回数に限り、メンターによるオンラインサポート（以下「メンタリング」といいます）を受けることができます。
        </li>
        <li class="mb-2">
          メンタリング実施日程は、あらかじめ会員と当社が協議のうえ決定するものとします。
        </li>
        <li class="mb-2">
          メンタリングのキャンセルは、メンタリング開始予定時間の24時間前までに当社の定める方法によりキャンセルの申し出を行った場合に限り認められるものとし、その後のキャンセルはできないものとします。
        </li>
        <li class="mb-2">
          会員がメンタリング開始時間までにメンターに通知することなく無断欠席、もしくはキャンセルを合計2回した場合、本サービスの運営を妨害したものとし、会員はその後のメンタリングを受ける権利を失うものとします。なお、それによる会員に生じる損害等に関し当社は一切の責任を負わず、メンタリング料金の返金も行わないものとします。
        </li>
        <li class="mb-2">
          会員は担当メンターの指名および変更は行えないものとします。ただし、当社が担当メンター変更の必要があると認めた場合はこの限りではありません。
        </li>
      </ol>
    </div>

    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第7条（チャットサポート）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、メンターへの質問をいつでも投稿できるものとします。
        </li>
        <li class="mb-2">
          メンターからの回答は、当社所定の時間に行うものとします。
        </li>
        <li class="mb-2">
          会員は回答するメンターの指名および変更は行えないものとします。
        </li>
      </ol>
    </div>

    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第8条（カスタマーサポート）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、本サービス利用に際しての不明点を<a href="/contact">お問い合わせフォーム</a>よりお問い合わせすることができます。
        </li>
        <li class="mb-2">
          お問い合わせ送信後、2営業日以内を目安に回答するものとします。
        </li>
        <li class="mb-2">
          電話でのお問い合わせは行えないものとします。
        </li>
      </ol>
    </div>

    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第9条（禁止事項）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、本サービスの利用に際して、以下に定めることを行ってはなりません。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              本サービスを利用する権利を第三者に譲渡、使用、売買、名義変更、質権の設定、担保に供すること
            </li>
            <li class="mb-2">
              コンテンツを、本サービスが予定している利用形態を超えて利用（複製、送信、転載、改変などの行為を含む）する行為
            </li>
            <li class="mb-2">
              当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為
            </li>
            <li class="mb-2">
              アクセス情報を第三者に譲渡、貸与等することまたは第三者に使用させること
            </li>
            <li class="mb-2">
              当社の営業、名誉、信用、著作権・特許権・実用新案権・商標権及びその他の知的財産権、肖像権、プライバシーなどを侵害すること
            </li>
            <li class="mb-2">
              違法行為、公序良俗に反すること
            </li>
            <li class="mb-2">
              本サービスの運営を妨げること
            </li>
            <li class="mb-2">
              本サービスを直接自己または第三者の営業行為として利用すること
            </li>
            <li class="mb-2">
              本サービスにて利用する第三者の外部サービスに関する質問等、本サービスとは直接関連しない内容に関する質問・相談を当社メンターに対し行うこと。
            </li>
            <li class="mb-2">
              他の会員、当社メンター及び当社従業員に違法行為を勧誘または助長すること
            </li>
            <li class="mb-2">
              他の会員、当社メンター及び当社従業員が経済的・精神的損害、不利益を被ること
            </li>
            <li class="mb-2">
              犯罪行為及び犯罪行為に結びつく行為
            </li>
            <li class="mb-2">
              当社メンターへの嫌がらせや、不良行為などレッスンの進行を妨げる等のハラスメント行為
            </li>
            <li class="mb-2">
              当社メンターの雇用条件など一般に開示していない当社の機密情報を詮索すること
            </li>
            <li class="mb-2">
              当社メンターに対する一切の勧誘行為
            </li>
            <li class="mb-2">
              手段の如何を問わず、本サービス以外の機会に当社メンターに接触しようとすること
            </li>
            <li class="mb-2">
              当社の従業員への暴言・脅迫行為及びその他当社の業務を妨げること
            </li>
            <li class="mb-2">
              １つのアクセス情報を会員本人以外の者と共有し会員本人以外の者に本サービスを利用させる行為及び１人の会員が複数の会員登録をすること
            </li>
            <li class="mb-2">
              当社メンターの個人情報を得ようとしたり、本サービス以外で面会を勧誘すること。
            </li>
            <li class="mb-2">
              本サービスにおいて利用するチャット上で、当社または本サービスに対する誹謗中傷や他の会員への嫌がらせの書き込みなどを行う等、本サービスの健全な運営を妨げること。
            </li>
            <li class="mb-2">
              本サービスの全部または一部を基にしたサービスを提供すること
            </li>
            <li class="mb-2">
              第3条（利用可能時間）、第5条（利用期間）、第6条（メンタリング）、第7条（チャットサポート）、第8条（カスタマーサポート）の範囲を超えたサポートの要求など、社会通念上過剰なサービス提供の要求
            </li>
            <li class="mb-2">
              合理的理由のない当社への謝罪要求や当社関係者への処罰の要求
            </li>
            <li class="mb-2">
              同じ要望や苦情の過剰な繰り返し等による長時間の拘束行為
            </li>
            <li class="mb-2">
              SNSやインターネット上での誹謗中傷
            </li>
            <li class="mb-2">
              学習に関わる解答やデータ等を要求する行為
            </li>
            <li class="mb-2">
              その他、本サービス運営上、当社が不適当と判断すること
            </li>
          </ol>
        </li>
        <li class="mb-2">
          会員または利用者は、前項に違反する行為に起因して当社または第三者に損害が生じた場合、本サービスからの退会後であっても、すべての法的責任を負うものとし、いかなる場合も当社を免責するものとします。
        </li>
        <li class="mb-2">
          当社は、本サービスで利用するチャット上において、会員が本条第1項に該当する禁止行為を行った場合は、該当するチャットを会員の同意なく削除することができるものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第10条（退会）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、当社所定の方法により退会申請を行うことで退会することができます。なお、退会後は本サービスを利用することができません。
        </li>
        <li class="mb-2">
          当社は、本規約の各規定に従って、会員を退会させることができるものとします。この場合、当社が会員に退会処分をした旨を電子メール等で通知した時点で退会手続きの完了とします。この場合、退会手続きの完了以降本サービスを利用することはできなくなります。
        </li>
        <li class="mb-2">
          会員は、退会後、本サービスに関する一切の権利を失うものとし、当社に対していかなる請求（利用料金の返還を含みます。）も行うことができないものとします。また、退会した後、再度会員登録した場合であっても、過去の受講履歴等の閲覧は一切できないものとします。
        </li>
        <li class="mb-2">
          会員は、自身の行為等に起因して当社または第三者に損害が生じた場合、退会後であっても、すべての法的責任を負うものとし、いかなる場合も当社を免責するものとします。
        </li>
        <li class="mb-2">
          当社は、会員が、以下の各号のいずれかに該当する場合は、事前に通知・催告することなく、当該会員の本サービスの利用を一時的に停止し、または会員登録を削除することができるものとます。その場合、利用停止および削除等関する質問・苦情は一切受け付けておりません。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              本規約に違反したと当社が判断した場合
            </li>
            <li class="mb-2">
              登録した情報が真実かつ正確ではないと判明した場合
            </li>
            <li class="mb-2">
              支払停止もしくは支払不能となり、または破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始その他の倒産手続の開始の申立てがあった場合
            </li>
            <li class="mb-2">
              反社会的勢力等（暴力団、暴力団員、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団、反社会的勢力、その他これに準ずる者をいいます。）であると当社が判断した場合、または資金提供等を通じて反社会的勢力等の維持、運営または経営に協力または関与する等反社会的勢力等と何らかの交流・関与を行っていると当社が判断した場合
            </li>
            <li class="mb-2">
              その他当社が適当でないと判断した場合
            </li>
          </ol>
        </li>
        <li class="mb-2">
          当社は、あらかじめ会員に通知・催告することなく、最終の利用から100日以上経過している会員の登録を削除することができるものとします。
        </li>
        <li class="mb-2">
          会員が死亡した場合、当社は、当該会員の登録を削除できるものとします。また、会員が死亡した場合、その時点で本サービスを退会したものとし、当該会員が有していた本サービスに関する権利・義務は当該会員に一身専属に帰属し、相続されないものとします。
        </li>
        <li class="mb-2">
          会員が誤って会員登録を削除した場合も、会員登録の復旧を行うことはできず、本サービスを再度利用する場合には、あらためて会員登録を行うものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第11条（通知）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          当社の会員に対する通知は、当社サイト上への掲載または会員登録されたメールアドレスへの電子メールの送信により行なうものとし、当社サイト上への掲載の場合は掲載された時点をもって、また、電子メールの送信の場合は電子メールが送信された時点をもって、通知が完了したものとみなします。
        </li>
        <li class="mb-2">
          会員は、会員登録した自らのメールアドレスにより当社からの電子メールを受信できるよう設定しなければなりません。
        </li>
        <li class="mb-2">
          当社は、本サービスに関する情報等を電子メールで会員に通知する場合、会員が当社からの電子メールの受信を拒否する設定をした場合でも、会員登録されたメールアドレス宛に送信した時点をもって通知が完了したものとみなします。
        </li>
        <li class="mb-2">
          当社は、会員が会員登録したメールアドレスに不備があったこと、会員がメールアドレスの変更を当社に通知しなかったことまたは会員が適切に受信設定しなかったことに起因して当社からの電子メールが会員に届かなかった場合、同不到達に対して、一切責任を負わないものとします。なお、会員は、同不到達に起因して生じるすべての損害等について責任を負うものとし、いかなる場合も当社を免責するものとします。
        </li>
        <li class="mb-2">
          本サービスに関する会員から当社への通知・連絡は、当社サイト内の適宜の場所に設置するお問い合わせフォームの送信または当社が指定する方法により行うものとします。会員から通知・連絡があった場合、当社は、当社所定の方法により、会員の本人確認を行うことができるものとします。また、会員からの通知・連絡に対する回答方法については、その都度当社が最適と考える方法により回答することができるものとし、その回答方法を会員が指定することはできないものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第12条（本サービスの中断および休止）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          当社は、通信設備等のメンテナンスなど本サービスを適切に提供するために必要がある場合は、事前に会員に通知することによりシステムを休止することができるものとし、この場合会員は本サービスを利用できないことに同意するものとします。
        </li>
        <li class="mb-2">
          当社は、以下の事由により本サービスの提供が困難な場合、予告なしに本サービスを中断・休止することができるものとし、この場合、会員は本サービスを利用できないことに同意するものとします。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              本サービス用のハード・ソフト・通信機器設備等に関わるメンテナンスや修理を定期的又は緊急に行う場合
            </li>
            <li class="mb-2">
              アクセス過多、その他予期せぬ要因でシステムに負荷が集中した場合
            </li>
            <li class="mb-2">
              会員のセキュリティを確保する必要が生じた場合
            </li>
            <li class="mb-2">
              電気通信事業者の役務が提供されない場合
            </li>
            <li class="mb-2">
              天災等の不可抗力により本サービスの提供が困難な場合
            </li>
            <li class="mb-2">
              火災、停電、その他の不慮の事故又は戦争、紛争、動乱、暴動、労働争議等により本サービスの提供が困難な場合
            </li>
            <li class="mb-2">
              法令又はこれらに基づく措置により本サービスの運営が不能となった場合
            </li>
            <li class="mb-2">
              その他前各号に準じ当社が必要と判断した場合またはその他やむを得ない事由による場合
            </li>
          </ol>
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第13条（免責事項）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        会員は、下記の各条項に定める事項に起因または関連して生じた一切の損害について、当社がいかなる賠償責任も負わないことに予め同意します。
      </p>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          本サービスの利用に際し、満足な利用ができなかった場合（以下の状況を含みますが、これらに限定されません）
        </li>
        <li class="mb-2">
          希望する特定の時間帯でのメンターによる指導が受けられなかった場合、または会員がメンターに行った質問に対し、会員が希望する時間内にメンターによる回答が行われなかった場合
        </li>
        <li class="mb-2">
          希望する特定のメンターのチャット指導が受けられなかった場合
        </li>
        <li class="mb-2">
          受講コースの学習内容に直接関連しない質問等に対して、メンターによる指導や回答が受けられなかった場合
        </li>
        <li class="mb-2">
          第三者による会員登録した情報への不正アクセス及び改変など
        </li>
        <li class="mb-2">
          本サービスの学習効果や有効性、正確性、真実性等
        </li>
        <li class="mb-2">
          本サービスに関連して当社が紹介・推奨する他社の教材等の効果及び有効性ならびに安全性及び正確性等
        </li>
        <li class="mb-2">
          本サービスに関連して受信したファイル等が原因となりウィルス感染などの損害が発生した場合
        </li>
        <li class="mb-2">
          パスワード等の紛失または使用不能により本サービスが利用できなかった場合
        </li>
        <li class="mb-2">
          本サービス上で提供するすべての情報、リンク先等の完全性、正確性、最新性、安全性等
        </li>
        <li class="mb-2">
          本サービス上で利用した第三者のサービスの完全性、正確性、最新性、安全性等
        </li>
        <li class="mb-2">
          会員が作成したプログラムの有効性ならびに安全性及び正確性等
        </li>
        <li class="mb-2">
          本サービスの利用に関して、会員がサービスを利用したことまたは利用できなかったことに起因する一切の事由
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第14条（著作権等）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          本サービスにおいて、お客様に提供するテキスト、ファイル・データ等の著作権、商標権等の一切の権利はメンター、または当社に帰属します。これらの一部または全部を許可なく複製、上演、公衆送信（自動公衆送信の場合にあっては送信可能化を含みます）、譲渡、貸与、改変等することは禁止されています。
        </li>
        <li class="mb-2">
          前項に反した場合、民事上の措置（損害賠償等）及び刑事上の措置をとらせていただくことがあります。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第15条（会員に関する情報の収集、解析及び取扱い）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          当社による登録情報、端末情報等その他会員に関する情報の取扱いについては、別途定めるプライバシーポリシーによるものとし、会員は、プライバシーポリシーに従って当社が当該情報を取り扱うことについて同意するものとします。
        </li>
        <li class="mb-2">
          当社は、会員が当社に提供した登録情報、端末情報等及びその他の情報及びデータ等を、当社の裁量で、本サービスの提供及び運用、サービス内容の改良及び向上等の目的のために利用し、又は個人を特定できない形での統計的な情報として公開することができるものとし、会員はこれに同意するものとします。
        </li>
        <li class="mb-2">
          当社は、会員が提携サービスの利用を希望するときは、会員から収集した登録情報、端末情報等、その他当該会員に関する情報を、当該提携サービスの利用に必要な範囲において、提携パートナーに提供することがあり、会員はこれに同意するものとします。
        </li>
        <li class="mb-2">
          前項の他、当社は、第2項に定める目的及び提携パートナーによる提携サービスの提供を目的として、本サービスを通じて収集・解析した情報に関する統計資料を提携パートナーその他の第三者に提供することがあり、会員はこれに同意するものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第16条（処分規定）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          当社は、会員が下記のいずれかに該当し、またはそのおそれがあると当社が判断した場合、当該会員に対して、本サービスの利用の一時停止または退会の処分を行うことができるものとします。その場合、右の措置に関する質問・苦情は一切受け付けておりません。また、当社は、本条に基づき当社が行った措置に関連して会員に損害が生じたとしても一切の責任を負いません。
          <ol
            class="mb-0 mt-2 pl-6 leading-8 md:ml-4 md:pl-7"
            style="list-style-type: lower-alpha"
          >
            <li class="mb-2">
              第9条（禁止事項）に定める禁止行為を行った場合
            </li>
            <li class="mb-2">
              本規約の各規定に違反した場合
            </li>
            <li class="mb-2">
              本サービスの利用に関し当社または当社メンターからの指示等に従わなかった場合
            </li>
            <li class="mb-2">
              その他当社が会員による本サービスの利用を不適切と判断した場合
            </li>
          </ol>
        </li>
        <li class="mb-2">
          会員が前項に基づき当社から一時停止の処分を受けた場合であっても当該会員の利用期間の延長及び利用料金の返金はいたしません。また、退会の処分を行った場合、当該会員に対して利用料金の返金を一切行わないものとします。会員は予めこれらの取り扱いに同意した上で本サービスを利用するものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第17条（会員の責任）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          必要な機器の準備等
          <p class="mb-4 ml-4 mt-3">
            本サービスの提供を受けるために必要な、コンピュータ、Webカメラ、マイク、スマートフォンその他の機器、ソフトウェア、通信回線その他の通信環境等は、会員の費用と責任において準備し維持するものとします。当社は、本サービスがあらゆる機器等に適合することを保証するものではありません。
          </p>
        </li>
        <li class="mb-2">
          自己の責任による利用
          <p class="mb-4 ml-4 mt-3">
            会員は、自らの責任において本サービスを利用するものとし、本サービスにおいて行った一切の行為およびその結果について一切の責任を負うものとします。
          </p>
        </li>
        <li class="mb-2">
          第三者との紛争
          <p class="mb-4 ml-4 mt-3">
            本サービスに関連して会員と第三者との間において生じた紛争等については会員の責任において解決するものとし、当社はかかる事項について一切責任を負いません。
          </p>
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第18条（無保証および損害賠償）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          当社は、本規約に明示するものを除き、 本サービスにつき如何なる保証も行うものでもなく、本サービスに事実上または法律上の瑕疵がないことを保証するものではありません。
        </li>
        <li class="mb-2">
          会員は、本サービスを利用したことに関連して、当社が直接的もしくは間接的に何らかの損害（弁護士費用の負担を含みます。）を被った場合（当社が会員の利用を原因とする請求等を第三者より受けた場合を含みます。）、当社の請求に従って直ちにこれを補償するものとします。
        </li>
        <li class="mb-2">
          当社は、当社による本サービスの提供の停止、終了または変更、退会処分、本サービスの利用によるデータの消失または機器の故障等、その他本サービスに関連して会員が被った損害につき、賠償する責任を一切負わないものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第19条（サービスの変更または譲渡等）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          <p>本サービスの変更</p>
          <p class="mb-4 ml-4 mt-3">
            当社は、当社が必要と判断する場合、あらかじめ会員に通知することなく、いつでも、本サービスの全部または一部の内容を変更することができるものとします。
          </p>
        </li>
        <li class="mb-2">
          <p>本サービスの終了</p>
          <p class="mb-4 ml-4 mt-3">
            当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社は会員に事前に通知するものとします。
          </p>
        </li>
        <li class="mb-2">
          <p>会員の限定</p>
          <p class="mb-4 ml-4 mt-3">
            当社は、本サービスの全部または一部を、年齢、本人確認の有無その他の当社所定の条件を満たした会員に限定して提供することができるものとします。
          </p>
        </li>
        <li class="mb-2">
          <p>事業譲渡</p>
          <p class="mb-4 ml-4 mt-3">
            当社が本サービスに係る事業を第三者に譲渡する場合（事業譲渡、会社分割その他本サービスが移転する一切の場合を含む。）には、当該事業の譲渡に伴い、会員の本規約に基づく契約上の地位、本規約に基づく権利・義務および会員登録に伴い登録された情報その他の情報を、当社は当該事業の譲受人に譲渡することができるものとし、会員は、かかる譲渡につき予め承諾するものとします。
          </p>
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第20条（一般規定）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、当社の書面による事前の承諾なく、本規約に基づく契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、貸与、その他の処分をすることはできません。
        </li>
        <li class="mb-2">
          本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効と判断された場合であっても、本規約の残りの規定および一部が無効と判断された規定の残りの部分は、継続して有効に存続し、当該無効とされた条項またはその一部を、有効とするために必要な範囲で修正し、最大限、当該無効とされた条項またはその一部の趣旨および法律的経済的に同等の効果が確保されるよう解釈されるものとします。
        </li>
        <li class="mb-2">
          本規約に定めのない事項または本規約の解釈に疑義が生じた場合には、会員は、当社の定めるところに従うものとします。これにより解決しない場合には、当社および会員は、信義誠実の原則に従って協議の上速やかに解決を図るものとします。
        </li>
        <li class="mb-2">
          本規約は、日本法に準拠して解釈されるものとします。また、当社、会員は、本サービスまたは本規約に起因もしくは関連して当社と会員の間で生じた紛争の解決について、東京簡易裁判所または東京地方裁判所を第一審専属管轄裁判所とすることに予め合意するものとします。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第21条（規約の変更）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        当社は、本規約を事前の承諾通知なく、変更することができるものとします。本規約の変更は、変更後の規約が当社サイトに掲示された時点で効力が生じるものとし、当該変更の後、本サービスを利用した会員は、かかる変更に同意したとみなされるものとします。
      </p>
    </div>
    <div class="mb-10">
      <h2 class="co-display-7 mb-7 border-b-[3px] border-co-gray-200 pb-2 font-bold tracking-normal">
        第2章（キャリア支援についての特則）
      </h2>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第22条（定義）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          キャリア支援サービス
          <p class="mb-4 ml-4 mt-3">
            エージェントサービス及びスカウトサービスのことをいいます。
          </p>
        </li>
        <li class="mb-2">
          求職者
          <p class="mb-4 ml-4 mt-3">
            本規約第2条（申込及び登録）第2項の定めに従い、本サービスの有効な利用登録を受けた会員の内、本規約第24条（キャリア支援サービスの申込み）の定めに従い、キャリア支援サービスの利用申込を行った者をいいます。
          </p>
        </li>
        <li class="mb-2">
          求人者
          <p class="mb-4 ml-4 mt-3">
            キャリア支援サービスを利用して求人を行う者をいいます。
          </p>
        </li>
        <li class="mb-2">
          エージェントサービス
          <p class="mb-4 ml-4 mt-3">
            当社スタッフが、求職者の適正に合致すると思われる求人情報を提案し、就職を支援するサービス及びそれに付随するサービスをいいます。
          </p>
        </li>
        <li class="mb-2">
          スカウトサービス
          <p class="mb-4 ml-4 mt-3">
            次条に定めるサービスをいいます。
          </p>
        </li>
        <li class="mb-2">
          提携エージェント
          <p class="mb-4 ml-4 mt-3">
            当社と提携する事業者であり、希望する求職者に対し、自身の取り扱う求人情報を提案し、就職を支援する者をいいます。
          </p>
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第23条（スカウトサービスの内容）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          求職者は、求人者があらかじめ登録した求人内容に対し、スカウトサービスを通じて申し込むことができます。
        </li>
        <li class="mb-2">
          求職者は、求人者又は提携エージェントから、スカウトサービスを通じて、個別に求人情報を受け取ることができます。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第24条（キャリア支援サービスの申込み）
      </h3>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          会員は、有効に利用登録されている期間内に限り、当社の定める様式で職務経歴等を入力することにより、キャリア支援サービスの利用申込を行うことができます。
        </li>
        <li class="mb-2">
          前項の申込みが完了した時点で、キャリア支援サービスの利用契約が成立します。
        </li>
        <li class="mb-2">
          求職者は、職務経歴等に変更が生じた場合、直ちに修正を行うものとします。
        </li>
        <li class="mb-2">
          求職者は、職務経歴等に、自己又は他者の個人情報（住所、メールアドレス、電話番号等）を記載してはならないものとします、ただし、履歴書に自己の個人情報を記載する場合はこの限りではありません。
        </li>
        <li class="mb-2">
          求職者は、いつでも、当社の定める方法により、キャリア支援サービスの利用を解除することができます。
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第25条（利用料金）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        キャリア支援サービスは無料でご利用いただけます。
      </p>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第26条（禁止行為の特則）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        求職者は、本規約第9条（禁止事項）の定めに加え、キャリア支援サービスの利用に際して、以下に定めることを行ってはなりません。
      </p>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          求人者又は提携エージェントからの情報をキャリア支援サービスの目的外に利用すること
        </li>
        <li class="mb-2">
          虚偽の情報を登録すること
        </li>
      </ol>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第27条（職業紹介について）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        エージェントサービスは、職業安定法に規定される職業紹介事業にあたります。
      </p>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第28条（個人情報）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        第15条（ユーザーに関する情報の収集、解析及び取り扱い）の定めにかかわらず、求職者は、管理画面上で公開する旨を選択した個人情報は求人者に公開されることをあらかじめ同意します。
      </p>
    </div>
    <div class="mb-10">
      <h3 class="co-display-10 mb-5 font-bold">
        第29条（免責事項の特則）
      </h3>
      <p class="mb-4 ml-4 leading-8">
        求職者は、本規約第13条（免責事項）の定めに加え、下記の各条項に定める事項に起因または関連して生じた一切の損害について、当社がいかなる賠償責任も負わないことに予め同意します。
      </p>
      <ol class="list-decimal pl-7 leading-8 md:ml-4">
        <li class="mb-2">
          求職者がキャリア支援サービスを通じて知り得た一切の情報（当社が提供した一切のもの並びに求人者、提携エージェント及びその他の第三者がキャリア支援サービスを通じて提供したものをいう）の、完全性、正確性、最新性、安全性等
        </li>
        <li class="mb-2">
          キャリア支援サービスを通じた個別の雇用契約等の成否、結果等
        </li>
        <li class="mb-2">
          求職者がキャリア支援サービス上で登録又は求人者とやり取りした情報の保存、滅失（必要な情報については適宜バックアップをお願い致します。）
        </li>
        <li class="mb-2">
          キャリア支援サービスを利用することによって生じた、求職者と求人者、求職者相互間、求職者とその他第三者との間の紛争
        </li>
      </ol>
    </div>
    <p class="text-right">
      2012年10月30日制定<br>
      2021年3月11日改訂<br>
      2022年12月13日改訂<br>
      2023年7月3日改訂
    </p>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title: '利用規約 |テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
            'TechAcademyの利用規約です。オンラインブートキャンプのお申し込み前にご確認ください。',
            ogUrl: '/terms',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-terms-page-title {
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}
</style>
